import { first, shareReplay } from 'rxjs';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem,MessageService,ConfirmationService } from 'primeng/api';
import saveAs from 'file-saver';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { Table } from 'primeng/table';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss'],
})
export class VendorComponent implements OnInit {
  @ViewChild('vendorData', { static: true })
  public vendorData: Table;
  
  farmerAppDetails: any;
  farmerDetails: any;
  formData: any;
  village: any;
  villageList = [];
  filteredData: any[];
  isVendor: any;
  farmerId: any;
  farmerMobile: any;
  appVerificationItems: MenuItem[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];

  vendorMobile: any;
  public loading: boolean = false;
  public subscriptions: any = []
  public subjectSub:any;
  public selectedYear:any;

  constructor(
    public router: Router, 
    private dashboard: DashboardService, 
    private _personalDetalSer: FarmersDetailsService, 
    private confirmationService: ConfirmationService,
    private productService: BankDetailService, 
    private translateService: TranslateService, 
    private messageService: MessageService, 
    private cdref: ChangeDetectorRef,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService
    ) { }

  ngOnInit(): void {
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.farmerAppDetails, "Vendor_List");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.farmerAppDetails, "Vendor_List");
        }
      },
    ];
    
    this.loadDataAndApplyFilter();
  }

  loadData(){
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    let isVendorRole = loginDetails.get('isVendor') ? loginDetails.get('isVendor') : null;

    if (isVendorRole == "1") {
      const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
      const loginDetails = new Map(encDataD);
      const userId_ = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;
      
      this.isVendor = true;
      this.getFarmerAppDetailsByAtalLogin(userId_);
    }
    else {
      const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
      const farmerconfData = new Map(encData);
      let mobile = farmerconfData.get('farmerPh');
      this.farmerMobile = mobile;
      this.getFarmerPhone();
    }
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        this.loadData();
           
        this.selectedYear = res;
        this.vendorData.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  getFarmerAppDetailsByAtalLogin(userId: any) {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.vendorMobile = JSON.parse(payload)?.sub;

    // this.loader.start();
    this.loading = true;
    let sub = this.dashboard
    .getApplicationByAtal(userId)
    .pipe(first())
    .subscribe({
      next: (data) => {
        this.activityRecordService.activityRecord(this.vendorMobile, '7500 Applications', '', new Date(), 'Success');
        data.forEach(e=>{
          e.registerationDate_sort=new Date(e.registerationDate)
          e.registerationDate_filter=e.registerationDate_sort.toString().substring(4, 24)
        })
        this.farmerAppDetails = data;
        // this.loader.close();
        this.loading = false;
        // console.log("appdetails", this.farmerAppDetails);
      },
      error: (err) => {
        // this.loader.close();
        this.loading = false;
        this.activityRecordService.activityRecord(this.vendorMobile, '7500 Applications', '', new Date(), err);

        // console.log(err);
      },
    });

    this.subscriptions.push(sub);

    // this.dashboard.getApplicationByAtal(userId).subscribe(res => {
    //   this.farmerAppDetails = res;
    //   console.log("appdetails", this.farmerAppDetails);
    // })
  }

  onVendorFarmer() {
    sessionStorage.removeItem('farmerDetails');
    sessionStorage.removeItem('userID');
    sessionStorage.removeItem('farmerPh');
    sessionStorage.removeItem("isFarmerLogin");
    this.router.navigate(['/phone-login']);
  }

  getFarmerPhone() {
    // this.loader.start();
    this.loading = true;
    let sub = this.productService.getFarmerIdByMobileNo(this.farmerMobile)
    .pipe(first())
    .subscribe({
      next: (data) => {
        // this.loader.close();
        this.loading = false;
        if (data.statusCode === 200) {
          let far = JSON.parse(data.data);
          if (far.length > 0) {
            this.farmerId = far[0].Farmer_ID;
            this.getDetailsByFarmerId();
            sessionStorage.setItem("farmerId", this.farmerId);
          }
        }
      },
      error: (err) => {
        // this.loader.close();
        this.loading = false;
        // console.log(err);
      },
    })

    this.subscriptions.push(sub);

    // this.productService.getFarmerIdByMobileNo(this.farmerMobile)
    // .subscribe(resp => {
    //   if (resp.statusCode === 200) {
    //     let far = JSON.parse(resp.data);
    //     if (far.length > 0) {
    //       this.farmerId = far[0].Farmer_ID;
    //       this.getDetailsByFarmerId();
    //       sessionStorage.setItem("farmerId", this.farmerId);
    //     }
    //   }
    // })
  }

  getDetailsByFarmerId() {
    // this.loader.start();
    this.loading = true;
    this.dashboard.getApplicationByFarmerId(this.farmerId)
    .pipe(first())
    .subscribe({
      next: (res) => {
        this.farmerAppDetails = res;
        // this.loader.close();
        this.loading = false;
        
      },
      error: (err) => {
        // this.loader.close();
        this.loading = false;
      },
    })


    // this.dashboard.getApplicationByFarmerId(this.farmerId).subscribe(res => {
    //   this.farmerAppDetails = res;
    //   console.log("appdetails", this.farmerAppDetails);
    // })
  }

  getVillageData() {
    // this.loader.start();
    this.loading = true;
    this._personalDetalSer.getVillageMatserData()
    .pipe(first())
    .subscribe({
      next: (res) => {
        // console.log(res);
        this.villageList = res;
        // this.loader.close();
        this.loading = false;
        this.FarmersDetailsService();
        this.filteredData = [...this.villageList];
        // console.log("fil", this.filteredData);
        if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
      },
      error: (err) => {
        // this.loader.close();
        this.loading = false;
      },
    })


    // this._personalDetalSer.getVillageMatserData().subscribe(res => {
    //   console.log(res);
    //   this.villageList = res;
    //   this.FarmersDetailsService();
    //   this.filteredData = [...this.villageList];
    //   console.log("fil", this.filteredData);
    //   if (!window.localStorage.getItem("villageMaster")) {
    //     window.localStorage.setItem("villageMaster", JSON.stringify(res));
    //   }
    // })
  }

  FarmersDetailsService() {
   // this.loader.start();
   this.loading = true;
    this.dashboard.GetAllFarmerDetails()
    .pipe(first())
    .subscribe({
      next: (res) => {
        // console.log("details", res);
        this.farmerDetails = res;
        // this.loader.close();
        this.loading = false;
        this.formData = this.farmerDetails.find(x => x.Farmer_ID == this.farmerDetails[0].Farmer_ID);
        this.village = this.villageList.find(x => x.Code == this.formData.Village_Code);
        // debugger;
        //console.log("formData", this.village);
      },
      error: (err) => {
        // this.loader.close();
        this.loading = false;
      },
    })
    

    // this.dashboard.GetAllFarmerDetails().subscribe(res => {
    //   console.log("details", res);
    //   this.farmerDetails = res;
    //   this.formData = this.farmerDetails.find(x => x.Farmer_ID == this.farmerDetails[0].Farmer_ID);
    //   this.village = this.villageList.find(x => x.Code == this.formData.Village_Code);
    //   // debugger;
    //   console.log("formData", this.village);

    // })
  }

  editForm(appId) {
    this.router.navigate(['farmers-application', appId])
  }

  deleteForm(appId) {
    // this.loader.start();
    this.loading = true;
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // console.log("Hello")
        // console.log(appId)
        this.dashboard.deleteFarmerApplicationByAppId(appId)
          .pipe(first())
          .subscribe({
            next: () => {
              // this.loader.close();
            this.loading = false;
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Application deleted Successfully.' });

            },
            error: () => {
              // this.loader.close();
            this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Application Not Deleted.' });

            }
          });
      }
    });
  }


  // printForm(appId,vendorId,programId) {
  //   this.router.navigate(['dashboard', 'print', appId,vendorId,programId]);
  // }

 
  selectFarmerApplication(application) {
    if(application.appID){
      // this.loader.start();
      // this.dashboard
      // .getMIDetailByAppID(application.appID)
      // .pipe(first())
      // .subscribe({
      //   next: (res) => {
      //     this.loader.close();
      //     const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.appID), ,res[0]?.VendorId,res[0]?.ProgId]));
      //     window.open(link, '_blank');
      //   },
      //   error: (err) => {
      //     this.loader.close();
      //     console.log("error", err);
      //     this.messageService.add({
      //       severity: 'error',
      //       summary: 'Error Message',
      //       detail: err,
      //     });
      //   },
      // });
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.appID)]));
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.appID.toString()) } }));
      window.open(link, '_blank');
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
  }
}

exportExcel(modelData, filename) {
  if (!modelData) {
    modelData = [];
  }
  import("xlsx").then(xlsx => {
    let dataToSave = modelData.map((d: any) => {
      return {
        "App. No.":d.appID,
        "Farmer Name":d.farmerName,
        "Village":d.village,
        "Status":d.status,
        "Remarks":d.remarks,
        "Block":d.block,
        "District":d.district,
        "Date of Reg.":d.registerationDate
      }
    })
    const worksheet = xlsx.utils.json_to_sheet(dataToSave);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    const excelBuffer: any = xlsx.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });
    this.saveAsExcelFile(excelBuffer, filename);
  });
}

downloadSheetAsPdf(modelData, filename) {
  this.cols = [
    { field: 'appID', header: 'App. No.' },
    { field: 'farmerName', header: 'Farmer Name' },
    { field: 'village', header: 'Village' },
    { field: 'status', header: 'Status' },
    { field: 'remarks', header: 'Remarks' },
    { field: 'block', header: 'Block' },
    { field: 'district', header: 'District' },
    { field: 'registerationDate', header: 'Date of Reg.' },
  ];

  this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

  import("jspdf").then(jsPDF => {
    import("jspdf-autotable").then(x => {
      const doc = new jsPDF.default(0, 0);
      doc.autoTable(this.exportColumns, modelData);
      doc.save(`${filename}.pdf`);
    })
  })
}

saveAsExcelFile(buffer: any, fileName: string): void {
  import("file-saver").then(FileSaver => {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  });
}
}
